export default {
  rewardsWelcomeMessage:
    "Bienvenido a Wellth Rewards, donde puedes ganar recompensas por estar saludable! Obtenga la aplicación Wellth en ",
  restfulWelcomeMessage:
    "Welcome to Restful, {0}! We want you to earn rewards for getting a great night's sleep. Download the Restful app to get started: ",
};
